import React from 'react';

import logo from '../../../img/logo.svg';

import Title from './Title';
import LogoutButton from '../../LogoutButton';
import ShareButton from './ShareButton';
import ImageExportButton from './ImageExportButton';
import ZoomSettings from './ZoomSettings';
import WithChildrenSettings from './WithChildrenSettings';
import Tooltip from '../../common/Tooltip';
import { useCurrentBoard } from '../../../services/state';

import '../../../App.css';
import '../../../style/Common.css';
import '../../../style/Header.css';
import '../../../style/Modal.css';

const EditorHeader = () => {
  const { userRole } = useCurrentBoard();
  const isOwner = userRole === 'owner';

  return (
    <header className="Header">
      <div className="header-inner d-flex">
        <div className="logo-title-wrapper">
          <div className="logo m-r-1">
            <a href="/boards">
              <Tooltip title="Go to board list">
                <img src={logo} alt="circly" />
              </Tooltip>
            </a>
          </div>
          <Title />
        </div>

        <div className="action-btn-wrapper d-flex justify-content-center">
          <WithChildrenSettings />
          <ZoomSettings />
          <ImageExportButton />

          {/*	<button data-tip="set canvas to private" className="action-btn" onClick={() => this.saveImg()}><FiLock size={'1.5rem'} /></button> */}
          <ShareButton disabled={!isOwner} />
        </div>
        <div className="login d-flex justify-content-end">
          <LogoutButton />
        </div>
      </div>
    </header>
  );
};

export default EditorHeader;
